// MB-I18N-2A — help EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.poshelp.title": "POS Help",
  "os.poshelp.intro": "Checkout essentials: payments, loyalty, wallet and quick troubleshooting, without leaving the POS.",
  "os.poshelp.guides_heading": "Checkout & troubleshooting guides",
  "os.poshelp.contact_heading": "Support contact",
  "os.poshelp.contact_cta": "Write to us",
  "os.kb.good_to_know": "Good to know",
};
